module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAA/0lEQVQ4T+WRLUsEYRSFn7MjAxoE2aDFj2LXuGAUw45otVn9BWIXxCl2q8WqoEWMgnExW/wIalhswsquR95RUIfZZdANojfdl3N47n3PFbla3PT0S8yJYCqvhbfhqiIWjtZ1+VlXbceDwy1WowFGM6HDnMT8u+mxA7XQR3AOjGQwc0rEWWZv8xC32FN92wcSy0XTMRfHG5oJWpK6AWR9vmwOlaRuvw0sLot9G1VgpZsnLBZA7mEoLf0X0HgVZidB6h1NSLVxDbfND9+XjIZimKiWy/emCU/PXUDlEMWuX361vmXUt6v9sbDrqe8EYz/5luFeyZaXHLH7XViAYNZeASQfcpBw00qiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ddgl_icon.png
// module id = Ueer
// module chunks = 1